import React from "react";
import { Link } from "react-router-dom";
import "../styles/NotFound.css";

function NotFound() {
    return (

        <div className="notfound-container">
            <video class="collab-hero-video" autoplay="0" loop playsinline="" src="/background.mp4" type="video/mp4"></video>
            <h1 className="notfound-code">404</h1>
            <h2 className="notfound-message" >Oops! Page Not Found</h2>
            <p className="notfound-desc">
                The page you're looking for doesn't exist or has been moved.
            </p>
            <Link to="/" className="notfound-btn">
                Go Back Home
            </Link>
        </div>
    );
}

export default NotFound;
